import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useEffect, useState } from 'react';
import { fetchLppListDpha } from "../../../../controller/dashboard/Cekmeter";
import { getCache } from "../../../../util/Cache";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faCircleExclamation, faFileExcel, faSpinner } from '@fortawesome/free-solid-svg-icons'
import { CSV } from "../../../../util/ExportFile";

export default function Lpp(){
    const [petugas, setPetugas] = useState<any>({});

    const handleSetPetugas = async () => {
        const dataLogin = await getCache("current_user");
        setPetugas(dataLogin);
    }

    const [tanggalChoose, setTanggalChoose] = useState<Date | null>(new Date());
    const [namaSmbChoose, setnamaSmbChoose] = useState<string>("");
    const [tanggalString, setTanggalString] = useState<string>("");
    const [tanggalStringRapi, setTanggalStringRapi] = useState<string>("");

    useEffect(() => {
        if (!tanggalChoose) {
            setTanggalString(""); 
            setTanggalStringRapi("");
            return; 
        }

        const y = tanggalChoose.getFullYear().toString().slice(-2);
        const m = (tanggalChoose.getMonth() + 1).toString().padStart(2, '0');
        const d = tanggalChoose.getDate().toString().padStart(2, '0');
        
        setTanggalString(`${y}${m}${d}`);
        setTanggalStringRapi(`${d}-${m}-${y}`);
    },[tanggalChoose])


    const [filteredLppDetail, setFilteredLppDetail] = useState<any[]>([]);
    const [loading, setLoading] = useState(false);
    const [checkedTransfers, setCheckedTransfers] = useState<Record<string, string>>({});
    const [error, setError] = useState<string | null>(null);

    const filterLppDetail = filteredLppDetail.filter(lpp => {
        const nama = lpp.NAMA?.toLowerCase() || "";
        const nsb = lpp.NOSAMW?.toLowerCase() || "";
        const search = namaSmbChoose?.toLowerCase() || "";

        const matchesSearch =
            nama.includes(search) ||
            nsb.includes(search);
        return matchesSearch;
    });

    const initDataDPHA = async () => {
        setLoading(true);
          try {
            const dpha = `DPHA${tanggalString}${petugas.loket}`
            const resp = await fetchLppListDpha(dpha);
            console.log(resp);
            setFilteredLppDetail(resp.data);
          } catch (err: any) {
            setError(String(err?.message ?? err));
          } finally {
            setLoading(false);
        }
    }
    useEffect(() => {
        handleSetPetugas();
    }, []);

    useEffect(() => {
        if(petugas.nama){
            let mounted = true;
            initDataDPHA();
            return () => { mounted = false; };
        }
    }, [tanggalString, petugas]);


    return(
        <>
            <div className="w-full max-w-screen px-2 md:px-4 lg:px-6 mx-auto">
                <div className="bg-white rounded-xl shadow-lg p-4 md:p-6 mb-6">
                    {/* Header */}
                    <div className="flex items-center justify-between mb-6 print:hidden">
                        <h3 className="text-lg md:text-xl font-semibold text-gray-800">
                            LPP {tanggalStringRapi}: {petugas.nama}, LOKET - {petugas.loket}
                        </h3>
                    </div>

                    {/* Grid Layout: Table (Left) + Sticky Controls (Right) */}
                    <div className="grid grid-cols-1 lg:grid-cols-12 gap-6">
                        {/* Table Section - 9 columns */}
                        <div className="lg:col-span-9">
                            <div className="w-full overflow-x-auto rounded-lg border border-gray-200">
                                {
                                loading ? (
                                    <div className="w-full p-8 text-center text-yellow-500">Sedang Loading <FontAwesomeIcon icon={faSpinner} spin /> </div>
                                ) : filterLppDetail && filterLppDetail.length >= 1 ? (
                                    <DetailPreviewRekapLppTableModal filteredLppDetail={filterLppDetail} />
                                ) : (
                                    <div className="w-full p-8 text-center text-red-500">Tidak ada data <FontAwesomeIcon icon={faCircleExclamation} /> </div>
                                )}
                            </div>
                        </div>

                        {/* Sticky Controls Section - 3 columns */}
                        <div className="lg:col-span-3">
                            <div className="sticky top-4 flex flex-col gap-3">
                                <input
                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => setnamaSmbChoose(e.target.value)}
                                    className="border border-gray-300 rounded-lg px-3 py-2 text-sm"
                                    placeholder="Nama atau NO. SMB" 
                                />
                                <DatePicker
                                    selected={tanggalChoose}
                                    onChange={(date: Date | null) => setTanggalChoose(date)}
                                    placeholderText="Pilih tanggal bayar"
                                    dateFormat="yyyy-MM-dd"
                                    className="border border-gray-300 rounded-lg px-3 py-2 text-sm"
                                    isClearable
                                />
                                

                                {filterLppDetail && filterLppDetail.length >= 1 && (
                                    <button
                                        onClick={() => { if(filteredLppDetail.length != 0) { CSV(filteredLppDetail, "Export_Lpp"); }}}
                                        className="flex items-center justify-center px-4 py-2 text-white bg-green-500 rounded-lg hover:bg-green-700 transition-colors text-sm font-medium gap-2"
                                    >
                                        <FontAwesomeIcon icon={faFileExcel} />
                                        <span>Download</span>
                                    </button>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export const DetailPreviewRekapLppTableModal = ({ filteredLppDetail }: { filteredLppDetail:   any[]; }) => {
  return (
    <table className="min-w-max whitespace-nowrap border border-gray-400 text-sm">
        <thead className="bg-gray-100">
            <tr>
                <th className="border px-3 py-2">NO</th>
                <th className="border px-3 py-2">PERIODE</th>
                <th className="border px-3 py-2">NSB</th>
                <th className="border px-3 py-2">NAMA</th>
                <th className="border px-3 py-2">KLS</th>
                <th className="border px-3 py-2">PLGGN</th>
                <th className="border px-3 py-2">HAIR</th>
                <th className="border px-3 py-2">ADM</th>
                <th className="border px-3 py-2">JML</th>
                <th className="border px-3 py-2">DENDA</th>
                <th className="border px-3 py-2">TOTAL</th>
            </tr>
        </thead>
        <tbody>
        { filteredLppDetail && filteredLppDetail.length > 0 ? (
            <>
           
                {filteredLppDetail.map((lpp: any, idx: number) => {


                    return(
                    <tr key={lpp.no} className="hover:bg-gray-50 transition-colors">
                        <td className="border px-3 py-2 text-center">{idx + 1}</td>
                        <td className="border px-3 py-2 text-center">{lpp.periode}</td>
                        <td className="border px-3 py-2 text-center">{lpp.NOSAMW}</td>
                        <td className="border px-3 py-2">{lpp.NAMA}</td>
                        <td className="border px-3 py-2 text-center">{lpp.KLASF}</td>
                        <td className="border px-3 py-2 text-center">{lpp.stat_smb === '30' ? 'Aktif' : lpp.stat_smb === '40' ? 'Segel' : lpp.stat_smb === '20' ? 'Cabut Meter' : lpp.stat_smb}</td>
                        <td className="border px-3 py-2 text-right">{(Number(lpp.R1) + Number(lpp.R2) + Number(lpp.R3) + Number(lpp.R4)).toLocaleString('id-ID', { style: 'decimal' })}</td>
                        <td className="border px-3 py-2 text-right">{Number(lpp.ADM).toLocaleString('id-ID', { style: 'decimal' })}</td>
                        <td className="border px-3 py-2 text-right">{((Number(lpp.R1) + Number(lpp.R2) + Number(lpp.R3) + Number(lpp.R4)) + Number(lpp.ADM)).toLocaleString('id-ID', { style: 'decimal' })}</td>
                        <td className="border px-3 py-2 text-right">{Number(lpp.DENDA).toLocaleString('id-ID', { style: 'decimal' })}</td>
                        <td className="border px-3 py-2 text-right font-semibold">{((Number(lpp.R1) + Number(lpp.R2) + Number(lpp.R3) + Number(lpp.R4)) + Number(lpp.ADM) + Number(lpp.DENDA)).toLocaleString('id-ID', { style: 'decimal' })}</td>
                    </tr>
                )}
            )}

                <tr className="font-bold bg-blue-100">
                    <td colSpan={6} className="border px-3 py-2 text-center">
                    TOTAL
                    </td>
                    <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.R1) + Number(t.R2) + Number(t.R3) + Number(t.R4) || 0), 0).toLocaleString('id-ID', { style: 'decimal' })}</td>
                    <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.ADM) || 0), 0).toLocaleString('id-ID', { style: 'decimal' })}</td>
                    <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.R1) + Number(t.R2) + Number(t.R3) + Number(t.R4) + Number(t.ADM) || 0), 0).toLocaleString('id-ID', { style: 'decimal' })}</td>
                    <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.DENDA) || 0), 0).toLocaleString('id-ID', { style: 'decimal' })}</td>
                    <td className="border px-3 py-2 text-right">{filteredLppDetail?.reduce((sum: number, t: any) => sum + (Number(t.R1) + Number(t.R2) + Number(t.R3) + Number(t.R4) + Number(t.ADM) + Number(t.DENDA) || 0), 0).toLocaleString('id-ID', { style: 'decimal' })}</td>
                </tr>
            </>
            ) : (
            <tr>
                <td colSpan={13} className="text-center py-4 text-gray-500">
                    Tidak ada data
                </td>
            </tr>
            )
        }
        </tbody>
    </table>
  );
};